module.exports = __webpack_public_path__ + "static/media/piano-annuale.312224cd.odt";